/**
 * @description Provides a helper class for anything SMS related.
 */
var SMSHelperService = function () {
    var self = this;

    /**
     * Set up the static object containing the 7 bit character set
     * The key value pairs are made up of the following:
     * - key = Character
     * - value = Number of characters used for the specified character in the SMS message
     */
    self.Charset7bit = {'@': 1, '£': 1, '$': 1, '¥': 1, 'è': 1, 'é': 1, 'ù': 1, 'ì': 1, 'ò': 1, 'Ç': 1, "\n":1, 'Ø': 1, 'ø': 1, "\r":1, 'Å': 1, 'å': 1, 'Δ': 1, '_': 1, 'Φ': 1, 'Γ': 1, 'Λ': 1, 'Ω': 1, 'Π': 1, 'Ψ': 1, 'Σ': 1, 'Θ': 1, 'Ξ': 1, 'Æ': 1, 'æ': 1, 'ß': 1, 'É': 1, ' ': 1, '!': 1, '"': 1, '#': 1, '¤': 1, '%': 1, '&': 1, "'":1, '(': 1, ')': 1, '*': 1, '+': 1, ',': 1, '-': 1, '.': 1, '/': 1, '0': 1, '1': 1, '2': 1, '3': 1, '4': 1, '5': 1, '6': 1, '7': 1, '8': 1, '9': 1, ':': 1, ';': 1, '<': 1, '=': 1, '>': 1, '?': 1, '¡': 1, 'A': 1, 'B': 1, 'C': 1, 'D': 1, 'E': 1, 'F': 1, 'G': 1, 'H': 1, 'I': 1, 'J': 1, 'K': 1, 'L': 1, 'M': 1, 'N': 1, 'O': 1, 'P': 1, 'Q': 1, 'R': 1, 'S': 1, 'T': 1, 'U': 1, 'V': 1, 'W': 1, 'X': 1, 'Y': 1, 'Z': 1, 'Ä': 1, 'Ö': 1, 'Ñ': 1, 'Ü': 1, '§': 1, '¿': 1, 'a': 1, 'b': 1, 'c': 1, 'd': 1, 'e': 1, 'f': 1, 'g': 1, 'h': 1, 'i': 1, 'j': 1, 'k': 1, 'l': 1, 'm': 1, 'n': 1, 'o': 1, 'p': 1, 'q': 1, 'r': 1, 's': 1, 't': 1, 'u': 1, 'v': 1, 'w': 1, 'x': 1, 'y': 1, 'z': 1, 'ä': 1, 'ö': 1, 'ñ': 1, 'ü': 1, 'à': 1, "\f": 2, '^': 2, '{': 2, '}': 2, '\\': 2, '[': 2, '~': 2, ']': 2, '|': 2, '€': 2};

    self.MaxChars7Bit = 160;
    self.MaxChars7BitMulti = 153;
    self.MaxChars16Bit = 70;
    self.MaxChars16BitMulti = 63;

    /**
     * Set up the profanities list and regex for use in isProfanitySafe method
     * - Add to this array if new terms are found
     */
    self.profanities = ["2g1c", "2 girls 1 cup", "acrotomophilia", "anal", "anilingus", "anus", "arsehole", "ass", "asshole", "assmunch", "auto erotic", "autoerotic", "babeland", "baby batter", "ball gag", "ball gravy", "ball kicking", "ball licking", "ball sack", "ball sucking", "bangbros", "bareback", "barely legal", "barenaked", "bastardo", "bastinado", "bbw", "bdsm", "beaver cleaver", "beaver lips", "bestiality", "bi curious", "big black", "big breasts", "big knockers", "big tits", "bimbos", "birdlock", "bitch", "black cock", "blonde action", "blonde on blonde action", "blow j", "blow your l", "blue waffle", "blumpkin", "bollocks", "bondage", "boner", "boob", "boobs", "booty call", "brown showers", "brunette action", "bukkake", "bulldyke", "bullet vibe", "bung hole", "bunghole", "busty", "butt", "buttcheeks", "butthole", "camel toe", "camgirl", "camslut", "camwhore", "carpet muncher", "carpetmuncher", "chocolate rosebuds", "circlejerk", "cleveland steamer", "clit", "clitoris", "clover clamps", "clusterfuck", "cock", "cocks", "coprolagnia", "coprophilia", "cornhole", "cum", "cumming", "cunnilingus", "cunt", "darkie", "date rape", "daterape", "deep throat", "deepthroat", "dick", "dildo", "dirty pillows", "dirty sanchez", "dog style", "doggie style", "doggiestyle", "doggy style", "doggystyle", "dolcett", "domination", "dominatrix", "dommes", "donkey punch", "double dong", "double penetration", "dp action", "eat my ass", "ecchi", "ejaculation", "erotic", "erotism", "escort", "ethical slut", "eunuch", "faggot", "fecal", "felch", "fellatio", "feltch", "female squirting", "femdom", "figging", "fingering", "fisting", "foot fetish", "footjob", "frotting", "fuck", "fucking", "fucker", "fuck buttons", "fudge packer", "fudgepacker", "futanari", "g-spot", "gang bang", "gay sex", "genitals", "giant cock", "girl on", "girl on top", "girls gone wild", "goatcx", "goatse", "gokkun", "golden shower", "goo girl", "goodpoop", "goregasm", "grope", "group sex", "guro", "hand job", "handjob", "hard core", "hardcore", "hentai", "homoerotic", "honkey", "hooker", "hot chick", "how to kill", "how to murder", "huge fat", "humping", "incest", "intercourse", "jack off", "jail bait", "jailbait", "jerk off", "jigaboo", "jiggaboo", "jiggerboo", "jizz", "juggs", "kike", "kinbaku", "kinkster", "kinky", "knobbing", "leather restraint", "leather straight jacket", "lemon party", "lolita", "lovemaking", "make me come", "male squirting", "masturbate", "menage a trois", "milf", "missionary position", "motherfucker", "mound of venus", "mr hands", "muff diver", "muffdiving", "nambla", "nawashi", "negro", "neonazi", "nig nog", "nigga", "nigger", "nimphomania", "nipple", "nipples", "nsfw images", "nude", "nudity", "nympho", "nymphomania", "octopussy", "omorashi", "one cup two girls", "one guy one jar", "orgasm", "orgy", "paedophile", "panties", "panty", "pedobear", "pedophile", "pegging", "penis", "phone sex", "piece of shit", "piss pig", "pissing", "pisspig", "playboy", "pleasure chest", "pole smoker", "ponyplay", "poof", "poop chute", "poopchute", "porn", "porno", "pornography", "prince albert piercing", "pthc", "pubes", "pussy", "queaf", "raghead", "raging boner", "rape", "raping", "rapist", "rectum", "reverse cowgirl", "rimjob", "rimming", "rosy palm", "rosy palm and her 5 sisters", "rusty trombone", "s&m", "sadism", "scat", "schlong", "scissoring", "semen", "sex", "sexo", "sexy", "shaved beaver", "shaved pussy", "shemale", "shibari", "shit", "shota", "shrimping", "slanteye", "slut", "smut", "snatch", "snowballing", "sodomize", "sodomy", "spic", "spooge", "spread legs", "strap on", "strapon", "strappado", "strip club", "style doggy", "suck", "sucks", "suicide girls", "sultry women", "swastika", "swinger", "tainted love", "taste my", "tea bagging", "threesome", "throating", "tied up", "tight white", "tit", "tits", "titties", "titty", "tongue in a", "topless", "tosser", "towelhead", "tranny", "tribadism", "tub girl", "tubgirl", "tushy", "twat", "twink", "twinkie", "two girls one cup", "undressing", "upskirt", "urethra play", "urophilia", "vagina", "venus mound", "vibrator", "violet wand", "vorarephilia", "voyeur", "vulva", "wank", "wet dream", "wetback", "white power", "women rapping", "wrapping men", "wrinkled starfish", "xx", "xxx", "yaoi", "yellow showers", "yiffy", "zoophilia"];
    self.profanityExpressions = _.map(self.profanities, function(entry) {
        return new RegExp("\\b(" + entry + ")\\b", "gi");
    });

    /**
     * Set up the list of priority uppercase words and regex for use in capitalizeWords method
     * - Add to this array if new words are required
     */
    self.uppercaseSearchMasks = [];
    self.uppercaseReplaceMasks = _.map(self.uppercaseSearchMasks, function(entry) {
        return entry.toUpperCase();
    });
    self.uppercaseExpressions = _.map(self.uppercaseSearchMasks, function(entry) {
        return new RegExp("\\b(" + entry + ")\\b", "gi");
    });

    /**
     * Gets 7 bit SMS max characters
     * @param {int} maxMessages
     * @returns {}
     */
    self.getCampaignMaxMessageChars7Bit = function(maxMessages) {
        if (maxMessages > 1) {
            return self.MaxChars7BitMulti * maxMessages;
        }else{
            return self.MaxChars7Bit;
        }
    };

    /**
     * Gets 16 bit SMS max characters
     * @param {int} maxMessages
     * @returns {}
     */
    self.getCampaignMaxMessageChars16Bit = function(maxMessages) {
        if (maxMessages > 1) {
            return self.MaxChars16BitMulti * maxMessages;
        }else{
            return self.MaxChars16Bit;
        }
    };

    /**
     * Gets SMS Message parts count
     * @param {string} content
     * @param {string} prefix
     * @param {string} suffix
     * @param {number} prefixLength
     * @param {number} suffixLength
     * @returns {object}
     */
    self.getSMSCount = function(content, prefix, suffix, prefixLength, suffixLength){
        // Sanitize parameters
        var suffixLen = 0;
        if (suffix === null || suffix === '') {
            if (suffixLength === null || isNaN(suffixLength)) {
                suffixLength = 0;
            }
            suffixLen = suffixLength;
        } else {
            suffixLength = null;
            suffixLen = suffix.length;
        }
        var prefixLen = 0;
        if (prefix === null || prefix === '') {
            if (prefixLength === null || isNaN(prefixLength)) {
                prefixLength = 0;
            }
            prefixLen = prefixLength;
        } else {
            prefixLength = null;
            prefixLen = prefix.length;
        }

        // Return a default object if the message IsNullOrEmpty
        if (content === null || content === '') {
            return {
                'charCount': 0,
                'charCountTotal': 0,
                'smsCount' : 1,
                'charsLeft' : self.MaxChars7Bit - suffixLen - prefixLen,
                'maxChars' : self.MaxChars7Bit - suffixLen - prefixLen,
                'message' : '',
                'chars16Bit': []
            }
        }

        var validMessageChars = [];
        var fullText = [prefix,content,suffix];
        var fullTextChars = fullText.join('').split('');
        var messageLength = 0;
        var chars_16Bit = [];

        // Step through the message characters to work out the 7bit character length from the charset7Bit Dictionary object.
        // If we find a non 7 bit character then add this to the unsupported characters array
        for (var i in fullTextChars) {
            var char = fullTextChars[i];
            if (self.Charset7bit[char] !== undefined) {
                // Add the valid character to the valid characters list
                validMessageChars.push(char);
                messageLength += self.Charset7bit[char];
            } else {
                // If the character is invalid then add it to the invalid list
                if (!_.contains(chars_16Bit, char)) {
                    chars_16Bit.push(char);
                }
            }
        }

        // Re-join the message string for return
        var message = self.removeInvalidChars(content);

        if (suffixLength !== null) {
            messageLength += suffixLength;
        }
        return self.smsCount(messageLength, message, prefixLen, suffixLen, chars_16Bit);
    };

    /**
     * SMS Count method
     * @param {int} chars
     * @param {boolean} enc_16
     * @returns {object}
     */
    self.smsCount = function(chars, message, prefixLen, suffixLen, chars16Bit) {
        var characters_left = 0;

        if (chars <= self.MaxChars7Bit) {
            characters_left = self.MaxChars7Bit - chars;
            return {
                'charCount': chars - suffixLen - prefixLen,
                'charCountTotal': chars,
                'smsCount' : 1,
                'charsLeft' : characters_left,
                'maxChars' : self.MaxChars7Bit,
                'message' : message,
                'chars16Bit': chars16Bit
            };
        }

        var sms_count = Math.ceil(chars / self.MaxChars7BitMulti);
        characters_left = (sms_count * self.MaxChars7BitMulti) - chars;
        return {
            'charCount': chars - suffixLen - prefixLen,
            'charCountTotal': chars,
            'smsCount' : sms_count,
            'charsLeft' : characters_left,
            'maxChars' : self.MaxChars7BitMulti,
            'message' : message,
            'chars16Bit': chars16Bit
        };
    };

    /**
     * Removes invalid characters and returns the valid string
     * @param {string} message
     * @returns {string}
     */
    self.removeInvalidChars = function(message){
        var validMessageChars = [];
        var messageChars = message.split('');
        for (var i in messageChars) {
            var char = messageChars[i];
            if (self.Charset7bit[char] !== undefined) {
                // Add the valid character to the valid characters list
                validMessageChars.push(char);
            }
        }
        return validMessageChars.join('');
    };

    /**
     * SMS Get Max Length
     * @param {int} maxChars
     * @param {int} maxSms
     * @param {int} suffixLen
     * @param {int} prefixLen
     * @returns {int}
     */
    self.getMaxLength = function(maxChars, suffixLen, prefixLen) {
        return maxChars - suffixLen - prefixLen;
    };

    /**
     * Checks that a message contains no profanities
     * @param {string} message
     * @returns {boolean}
     */
    self.isProfanitySafe = function(message) {
        if (message === null || message === undefined) {
            return true;
        }
        return _.every(self.profanityExpressions, function(entry){
            return !message.match(entry);
        });
    };

    /**
     * Capitilizes specific words from an array of regex patterns in a given string
     * @param {string} message
     * @returns {string}
     */
    self.capitalizeWords = function(message) {
        if (message === null || message === undefined) {
            return '';
        }
        _.each(self.uppercaseExpressions, function(entry, index){
            message = message.replace(entry, self.uppercaseReplaceMasks[index]);
        });
        return message;
    }
};

angular.module('dashboard')
    .service('SMSHelperService', [SMSHelperService]);